/**
 * The ONE place the official Shingare Industries logo is rendered (site header, footer). The artwork is a horizontal wordmark
 * — the orange-globe "G", "SHINGARE" and "INDUSTRIES PVT LTD" — so it already carries the company name; it is never stretched:
 * width/height are the file's real 340×71 pixels; callers size it with ONE dimension in CSS and pair it with `h-auto` (fixed width)
 * or `w-auto` (fixed height) so the other follows the true aspect ratio.
 *
 * variant "color"  the logo as supplied — for light surfaces (the header bar).
 * variant "white"  a single-colour white silhouette of the same file, for dark surfaces (the footer). No separate official white
 *                  version of the logo exists in the project; this is the same artwork rendered white, not a new mark.
 *
 * Source file: /sipl-logo-sm.png (340×71). The 1004×209 master /sipl-logo.png is used for structured data (see HomePage JSON-LD),
 * and the tab / home-screen icons are cut from the same master by scripts/build-favicon.py.
 *
 * Settings → Company → Logo (`logo_url`) overrides this static file when set, so the logo can be replaced from Admin without a
 * deploy — width/height are then left to the browser (no stored dimensions for an uploaded file) and `object-contain` keeps it
 * from stretching; empty (the default today) falls back to the exact file above, so nothing changes until an admin uploads one.
 */
import { useSettings } from "@/contexts/SettingsContext";
import { toAbsoluteUrl } from "@/lib/imageUrl";

export const BRAND = { src: "/sipl-logo-sm.png", width: 340, height: 71, alt: "Shingare Industries Pvt Ltd" };

export default function BrandLogo({ variant = "color", className = "", eager = true, alt = BRAND.alt }) {
  const { settings } = useSettings();
  const customSrc = settings?.logo_url ? toAbsoluteUrl(settings.logo_url) : "";
  return (
    <img
      src={customSrc || BRAND.src}
      width={customSrc ? undefined : BRAND.width}
      height={customSrc ? undefined : BRAND.height}
      alt={alt}
      decoding="async"
      loading={eager ? "eager" : "lazy"}
      draggable="false"
      className={`object-contain ${variant === "white" ? "[filter:brightness(0)_invert(1)]" : ""} ${className}`}
    />
  );
}
